// extracted by mini-css-extract-plugin
export default {"main-wrapper":"MessageThreadChat_main-wrapper__oFRz-","thread-messages-list":"MessageThreadChat_thread-messages-list__G2BJn","form-wrapper":"MessageThreadChat_form-wrapper__wQSCB"};